import React from "react";
import { NavLink } from "react-router-dom";
import FixedBottomMenu from "../FixedBottomMenu";
import styles from "./style.module.css";
import AtendimentoIco from "../Svg/new/atendimento";
import MeusDadosIco from "../Svg/new/meus-dados";
import ArquivosIco from "../Svg/new/arquivos";
import EnqueteIco from "../Svg/new/enquete";
import FinanceiroIco from "../Svg/new/financeiro";
import ProdutosIco from "../Svg/new/produtos";
import AgendaIco from "../Svg/new/agenda";
import FormandosIco from "../Svg/new/formandos";
import { SubContent } from "../Layout";
import useWrapper from "../../hooks/useWrapper";
import Button from "../Button";
import { toast } from "react-toastify";
import Logo from "../Logo";

export default function MenuTrainee() {
  const { me } = useWrapper();
  // acesso limitado/encerrado (distrato) só libera Meus Dados, Atendimento e
  // Financeiro — mesmo escopo que o backend já restringe em TraineeValidator
  const hasFullAccess = !me?.cancel && me?.access_status !== "limitado" && me?.access_status !== "encerrado";
  const Menu = [
    { label: "Meus Dados", link: "/formando-dashboard/meus-dados", ico: <MeusDadosIco /> },
    ...(hasFullAccess ? [{ label: "Agenda", link: "/formando-dashboard/agenda", ico: <AgendaIco /> }] : []),
    { label: "Atendimento", link: "/formando-dashboard/atendimento", ico: <AtendimentoIco /> },
    { label: "Financeiro", link: "/formando-dashboard/financeiro", ico: <FinanceiroIco /> },
    ...(hasFullAccess
      ? [
          { label: "Arquivos", link: "/formando-dashboard/arquivos", ico: <ArquivosIco /> },
          { label: "Enquetes", link: "/formando-dashboard/enquetes", ico: <EnqueteIco /> },
          { label: "Loja Virtual", link: "/formando-dashboard/produtos", ico: <ProdutosIco /> },
        ]
      : []),
    ...(!!me?.is_member && hasFullAccess
      ? [{ label: "Formandos", link: "/formando-dashboard/formandos", ico: <FormandosIco /> }]
      : []),
  ];

  return (
    <>
      <SubContent className="p-0">
        <div className="mb-4 pt-4 text-center">{me?.type === "Formando" && <Logo />}</div>
        <div className={`${styles.menu} d-lg-block d-none p-0`}>
          <ul className="p-0">
            {Menu.map(__menu_item => (
              <li>
                <NavLink to={__menu_item.link}>{__menu_item.label}</NavLink>
              </li>
            ))}
          </ul>
        </div>
        <div className={`d-lg-none d-block`}>
          <FixedBottomMenu menu={Menu} />
        </div>
      </SubContent>
      {!!me?.is_member && (
        <SubContent className="p-3 mt-lg-4">
          <input type="text" value={`${window.location.origin}/cadastro/${me?.commercials?.code_access}`} />
          <Button
            color="primary"
            onClick={() => {
              navigator.clipboard.writeText(`${window.location.origin}/cadastro/${me?.commercials?.code_access}`);
              toast.success("Convite Copiado!");
            }}
            className="w-100 mt-2"
          >
            Copiar Convite
          </Button>
        </SubContent>
      )}
    </>
  );
}
